import { render, staticRenderFns } from "./recibo-pagamento-escola-ilha-novo.vue?vue&type=template&id=6e410aae&scoped=true&"
import script from "./recibo-pagamento-escola-ilha-novo.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola-ilha-novo.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola-ilha-novo.vue?vue&type=style&index=0&id=6e410aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e410aae",
  null
  
)

export default component.exports